import { useEffect, useState } from 'react';
import { getStripeProductPrice } from '../lib/payments/stripe/stripeClient';
import { cardPriceKey, createCardPriceLoader } from '../lib/payments/stripe/cardPriceCache';

const loadCardPrice = createCardPriceLoader(getStripeProductPrice);

/** Uses the existing anonymous display callable, without starting checkout or loading a wallet. */
export function useCardPrice(product) {
  const key = cardPriceKey(product);
  const [state, setState] = useState({ key: '', price: null, loading: false });
  useEffect(() => {
    let mounted = true;
    if (!key) {
      setState({ key, price: null, loading: false });
      return undefined;
    }
    setState({ key, price: null, loading: true });
    const [id, priceId] = JSON.parse(key);
    loadCardPrice({ id, isActive: true, listingType: 'native', isFree: false,
      stripeConfig: { enabled: true, priceId } }).then((price) => {
      if (mounted) setState({ key, price, loading: false });
    }).catch(() => {
      if (mounted) setState({ key, price: null, loading: false });
    });
    return () => { mounted = false; };
  }, [key]);
  return state.key === key ? state : { key, price: null, loading: Boolean(key) };
}
